import React from 'react'
import styled, { css } from 'styled-components'
import { font, cardStyle } from 'features/dashboard/tokens'

const StatBox = ({ title, value, period, primary }) => {
  return (
    <StatBoxWrapper>
      <Title>{title}</Title>
      <ValueWrapper primary={primary}>
        {value} <span>{period}</span>
      </ValueWrapper>
    </StatBoxWrapper>
  )
}

export default StatBox

const StatBoxWrapper = styled.div`
  box-sizing: border-box;
  max-width: 300px;
  width: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
  height: 115px;
  ${cardStyle}
`

const Title = styled.div`
  font-size: ${font.emphasis};
  color: ${({ theme }) => theme.colors.haiti};
  margin-bottom: 10px;
`

const ValueWrapper = styled.div`
  font-size: ${font.title};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.secondary};
  
  ${({ primary }) => primary && css`
    color: ${({ theme }) => theme.colors.primary};
  `}
  
  span {
    font-size: ${font.emphasis};
    display: inline-block;
    margin-left: 3px;
    color: ${({ theme }) => theme.colors.grey[700]};
    font-weight: normal;
  }
`
